import type { SxProps, Theme } from "@mui/material"
import { dayjsUTC } from "../../utils/dates"

/** Row label column for site/county weekly charts (heatmap + bubbles). */
export const NWSS_WEEK_GRID_ROW_LABEL_WIDTH_PX = 56

export const buildNwssWeekChartGridSx = (weekCount: number): SxProps<Theme> => {
  const gridTemplateColumns = `${NWSS_WEEK_GRID_ROW_LABEL_WIDTH_PX}px repeat(${weekCount}, minmax(0, 1fr))`
  return {
    display: "grid",
    gridTemplateColumns,
    gap: "2px",
    alignItems: "center",
    width: "100%",
  } satisfies SxProps<Theme>
}

/** Left edge of a week column within the proportional chart track (0–100). */
export const weekColumnLeftPercent = (
  index: number,
  weekCount: number
): number => (weekCount <= 0 ? 0 : (index / weekCount) * 100)

/** First week column of a calendar month (for month-start header labels). */
export const isNwssWeekMonthStart = (
  weekKeys: readonly string[],
  index: number
): boolean => {
  if (index <= 0) return true
  const prevKey = weekKeys[index - 1]
  const currKey = weekKeys[index]
  if (prevKey === undefined || currKey === undefined) return false
  const prev = dayjsUTC(prevKey)
  const curr = dayjsUTC(currKey)
  return curr.month() !== prev.month() || curr.year() !== prev.year()
}
